import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import {LinkText} from '@/components/atoms';

/**
 * ReadOnlyField component displays a label and corresponding data in a read-only format.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.label - The label to display.
 * @param {string|number} props.data - The data to display next to the label.
 * @param {string} props.href - The href is redirect url while on LinkText click event.
 *
 * @returns {JSX.Element} The rendered read-only field component.
 */
const ReadOnlyFieldLinkText = (props) => {
  const navigate = useNavigate();
  const {label, data, uischema} = props;
  const {href = '#'} = uischema || {};
  return (
    <div className='oDP flex flex-row gap-4'>
      <div className='flex'>
        <div className='w100'>
          <div className='ptb'>
            <div className='flex gap-4'>
              <label className='lableColor text-[color:var(--color-text-secondary)]'>
                {label}
              </label>
            </div>
            <div className='flex gap-4'>
              <LinkText
                text={data}
                id={label + '_' + data}
                handleClick={() => navigate(href)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ReadOnlyFieldLinkText.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  uischema: PropTypes.shape({
    href: PropTypes.string
  })
};

export default React.memo(ReadOnlyFieldLinkText);
